<template>
  <preview-frame
    :show-preview-options="!section.desktopOnly"
    :preview-options="toggleOptions"
    :initial-preview-type="previewType"
    @update:model-value="handlePreviewTypeChange"
  >
    <slot name="global-widget" />
    <template
      #sections
    >
      <section-component
        v-if="previewSection"
        :key="changeCount"
        class="frame"
        demo-mode
        :section="previewSection"
        :is-phone-preview="!isDesktop"
        :style="applySectionBackground ? section.backgroundStyle : undefined"
        :class="[applySectionBackground ? section.class : undefined , !isDesktop ? undefined : 'zoom']"
      />
    </template>
  </preview-frame>
</template>

<script>
import { PREVIEW_OPTIONS } from 'src/models/page/Section'
import { SECTION_TYPES, WIDGET_DISPLAY_TYPES } from 'src/models/page/Section.js'
import PreviewFrame from 'src/modules/consumer/components/PreviewFrame'
import SectionComponent from 'src/modules/consumer/pages/SectionComponent'

export default {
  name: 'Preview',
  components: {
    SectionComponent,
    PreviewFrame
  },
  props: {
    section: {
      type: Object,
      default: null,
      required: false
    }
  },
  data () {
    return {
      previewType: !this.section.desktopOnly ? this.section.mobile ? 'mobile' : 'app' : 'desktop',
      changeCount: 0,
      // See updatePreviewSection comments regarding `previewSection`
      previewSection: null
    }
  },
  computed: {
    applySectionBackground () {
      return !((this.section.type === SECTION_TYPES.SITE_SELECTOR && this.section.config.siteSelectorWidgetDisplayType === WIDGET_DISPLAY_TYPES.POPUP) ||
       (this.section.type === SECTION_TYPES.MARKETING_SIGNUP && this.section.config.marketingSignupDisplayType === WIDGET_DISPLAY_TYPES.POPUP))
    },
    toggleOptions () {
      const toggleOptions = []
      if (this.section.desktop) {
        toggleOptions.push(PREVIEW_OPTIONS.DESKTOP)
      }
      if (this.section.mobile) {
        toggleOptions.push(PREVIEW_OPTIONS.MOBILE)
      } else if (this.section.app) {
        toggleOptions.push(PREVIEW_OPTIONS.APP)
      }
      return toggleOptions
    },
    isDesktop () {
      return this.previewType === PREVIEW_OPTIONS.DESKTOP.value
    }
  },
  watch: {
    'section.desktop': {
      handler () {
        this.phonePreviewCheck()
      },
      immediate: true
    },
    'section.mobile': {
      handler () {
        this.phonePreviewCheck()
      },
      immediate: true
    },
    'section.app': {
      handler () {
        this.phonePreviewCheck()
      },
      immediate: true
    },
    'section.config': {
      handler () {
        this.throttledUpdatePreviewSection()
        this.phonePreviewCheck()
      },
      immediate: true,
      deep: true
    },
    'section.language': {
      handler () {
        this.throttledUpdatePreviewSection()
      },
      immediate: false
    },
    'section.name' () {
      this.throttledUpdatePreviewSection()
    },
    'section.type': {
      handler () {
        this.phonePreviewCheck()
        this.throttledUpdatePreviewSection()
      },
      immediate: true
    }
  },
  created () {
    _.extend(this, { WIDGET_DISPLAY_TYPES, SECTION_TYPES })
  },
  methods: {
    phonePreviewCheck () {
      this.previewType = !this.section.desktopOnly ? this.section.mobile ? 'mobile' : 'app' : 'desktop'
    },
    // We clone the model on each update, which can be expensive, so we debounce it
    throttledUpdatePreviewSection () {
      if (!this._throttledUpdatePreviewSection) {
        this._throttledUpdatePreviewSection = _.throttle(this.updatePreviewSection, 300)
      }
      this._throttledUpdatePreviewSection()
    },
    // To avoid bad reactivity side effects, we prevent LocalizedJsonObjects from proxying with translation
    // keys in Admin mode (where translations editing is allowed). But we still want to preview the content
    // in Admin, so our workaround is to keep a clone of the original section updated, with the cloned
    // model.previewing = true allowing LocalizedJsonObjects to proxy with translation keys. We intentionally
    // do not use model.clone() because we need to set the `previewing` reactive property before the data is
    // set and made reactive, so that any LocalizedJsonObjects are initialized and proxied before reactivity.
    updatePreviewSection () {
      this.previewSection = new this.section.constructor({ options: this.section.options })
      this.previewSection.previewing = true
      this.previewSection.setData(this.section.deepCloneData())
    },
    handlePreviewTypeChange (type) {
      this.changeCount++
      this.previewType = type
    }
  }
}
</script>
